"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCustomClaimApi = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var apiRoutesBase_1 = require("../../routes/apiRoutesBase");
var deleteCustomClaimApi = function (_a) {
    var apiHeaders = _a.apiHeaders;
    return axios_1.default.delete(apiRoutesBase_1.apiRoutesBase.getBaseUrl() + (0, apiRoutesBase_1.apiRoutesBase)().customClaim.pathname, {
        headers: apiHeaders,
    });
};
exports.deleteCustomClaimApi = deleteCustomClaimApi;
